export default __webpack_public_path__ + "static/char-05-3b4cfbfaa7c66c1f698c04df309d22b7.webp";